class LocationMap extends HTMLElement {
  constructor() {
    super();
    this.mapEl = this.querySelector('[data-map]');
    this.getCoodinates();
    this.getPoiIcon();
    this.init();
  }

  getCoodinates() {
    if(!this.mapEl) return;

    this.lat = this.mapEl.dataset.lat;
    this.lng = this.mapEl.dataset.lng;
  }

  getPoiIcon() {
    if(!this.mapEl) return;

    this.poiIcon = this.mapEl.dataset.poi;
  }

  init() {
    if(!this.poiIcon || !this.lat || !this.lng) return;
  
    // CREATE MAP
    this.map = L.map('map', {
      scrollWheelZoom: false
    }).setView([this.lat, this.lng], 12);

    // ADD TILE LAYER TO MAP
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 22 }).addTo(this.map);
    
    // CREATE ICON
    this.mapPoi = L.icon({
      iconUrl: this.poiIcon,
      iconSize:     [32, 32],
      iconAnchor:   [16, 16]
    });

    // ADD POI TO MAP
    L.marker([this.lat, this.lng], { icon: this.mapPoi }).addTo(this.map);
  }
}

if(!customElements.get('location-map')) {
  customElements.define('location-map', LocationMap);
}